import { Component, OnInit, Input } from '@angular/core';
import { ToolsService } from 'src/app/@core/services/tools.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  utils: any;
  modalContent: any = { id: 'modal-any', content: '', name: '' }

  constructor(public tools: ToolsService, private sanitizer: DomSanitizer, ) {
    this.utils = window.utils;
    this.tools.$contentModal.subscribe((modal: any) => {
      if (Object.keys(modal).length !== 0) {
        this.utils.blurredBackgroundModal();
        this.modalContent = {
          ...modal,
          ... { content: this.sanitizer.bypassSecurityTrustHtml(modal.content) }
        }
      }
    });
  }
  ngOnInit() {
    window.utils.init();
  }
  sharpenBackgroundModal() {
    this.utils.sharpenBackgroundModal()
  }

  blurredBackgroundModal() {
    this.utils.blurredBackgroundModal()
  }
}
